const INFOVIEW_CLOSED = 'infoview-closed'

export {
  INFOVIEW_CLOSED
}
